import { TextField, Typography, Button } from "@material-ui/core";
import { Grid } from "@material/react-layout-grid";
import { useField } from "./../../../hooks/useField";
import { BPagoStyle } from "./BPagoStyles";
import BotonIcon from "./../../../global/BotonIcon";
import ClearTwoToneIcon from "@material-ui/icons/ClearTwoTone";
import { useDispatch } from "react-redux";
import { obtenerClientesAction } from "../../../ducks/pagoUnicoDuck";
import BackDrop from "../../../global/BackDrop";
import { useState } from "react";

const BPago = () => {

  const dispatch = useDispatch();
  const classes = BPagoStyle();
  const [load, setIsLoad] = useState(false);
  const nombre = useField({ type: "text" });
  const referencia = useField({ type: "text" });

  const onClear = () => {
    nombre.onResetValue();
    referencia.onResetValue();
    setIsLoad(true);
    dispatch(
      obtenerClientesAction("0", "0")
    ).then(Response =>{
      setIsLoad(false);
    });
  };

  const onBusacar = () =>{
    setIsLoad(true);
    dispatch(
      obtenerClientesAction(
        nombre.value !== "" ? nombre.value : "0",
        referencia.value !== "" ? referencia.value : "0"
      )
    ).then(Response =>{
      setIsLoad(false);
    });
  }

  return (
    <Grid className={classes.containerSpacing}>
      <Grid item xs={12} className={classes.modalBotones}>
        <Typography variant="subtitle1">
          Busqueda
        </Typography>
        <BotonIcon title="Limpiar" onClick={onClear}>
          <ClearTwoToneIcon />
        </BotonIcon>
      </Grid>
      <Grid item xs={12}>
        <TextField
          {...nombre}
          id="input-Nombre"
          label="Nombre"
          variant="outlined"
          name="nombre"
          className={classes.textField}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          {...referencia}
          id="input-Referencia"
          label="Referencia"
          variant="outlined"
          name="referencia"
          className={classes.textField}
        />
      </Grid>
      <Grid container className={classes.containerSpacing}>
          <Grid item xs={12} className={classes.modalBoton}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              className={classes.modalBoton}
              onClick={onBusacar}
            >
              Buscar
            </Button>
          </Grid>
        </Grid>
        <BackDrop open={load} />
    </Grid>
  );
};
export default BPago;
